import React from 'react';
import style from '../css/Box.module.css';
import { data } from '../data/Box_Date';

function Box() {
	return (
		<div className={style.container}>
			{data.map((item, index) => (
				<div key={index} className={style.Box}>
					<h1 className={style.title}>{item.title}</h1>
					<p className={style.desc}>{item.desc}</p>
					<img src={item.img} alt={item.title} className={style.image} />
				</div>
			))}
		</div>
	);
}

export default Box;
